import React from "react";

import PageMeta from "core/PageMeta";
import SectionContainer from "core/SectionContainer";
import HeaderSearch from "core/SiteHeader/HeaderSearch";
import Hero from "core/Hero";
import Collections from "core/Collections";
import BlogPosts from "core/BlogPosts";
import Promo from "core/Promo";

import colors from "core/colors";

import {
    heroTitle,
    heroSvgDesktop,
    heroSvgMobile,
    collectionsTitle,
    collections,
    pillsTitle,
    pills,
    recentPostsTitle,
    recentPosts,
    promo
} from "./data";

const HomeNP = () => {
    const metaDescription =
        "Noun Project has the most diverse collection of free icons and stock photos. Download SVG and PNG. Over 5 million art-quality icons and free photos.";
    return (
        <>
            <PageMeta
                title="Noun Project: Free Icons & Stock Photos for Everything"
                description={metaDescription}
                indexContent="index,follow,max-image-preview:large"
                canonicalURL="https://thenounproject.com/"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    name: "The Noun Project",
                    alternateName: "The Noun Project, Inc.",
                    url: "https://thenounproject.com/",
                    headline: heroTitle,
                    description: metaDescription,
                    logo:
                        "https://static.production.thenounproject.com/img/nounproject_logo.60e860f212a5.png",
                    inLanguage: "en",
                    sameAs: [
                        "https://twitter.com/nounproject",
                        "https://www.facebook.com/thenounproject",
                        "https://www.instagram.com/nounproject/",
                        "https://dribbble.com/nounproject",
                        "https://www.behance.net/noun_project",
                        "https://en.wikipedia.org/wiki/The_Noun_Project"
                    ],
                    potentialAction: {
                        "@type": "SearchAction",
                        target:
                            "https://thenounproject.com/search/?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                    }
                }}
            />

            <SectionContainer
                bgColor={colors.secondary.orca}
                textColor={colors.primary.diamond}
                isHero
                removeLeftRightPadding
            >
                <Hero
                    title={heroTitle}
                    desktopSvgUrl={heroSvgDesktop}
                    mobileSvgUrl={heroSvgMobile}
                    search={<HeaderSearch />}
                    headingColor={colors.primary.snow}
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <Collections
                    title={collectionsTitle}
                    collections={collections}
                    pillsTitle={pillsTitle}
                    pills={pills}
                />
            </SectionContainer>

            <SectionContainer>
                <BlogPosts
                    blogPostsTitle={recentPostsTitle}
                    posts={recentPosts}
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.primary.diamond}>
                <Promo promoContent={promo} />
            </SectionContainer>
        </>
    );
};

export default HomeNP;
